import "./Footer.css";


export const Footer = () => {
    return (
    <div className="Footer">
        <p className="foot" >@MiyanoChiri</p>
    </div> 
    )
}